import { ApisauceInstance } from 'apisauce';

const createCommitment = (c: CreateCommitmentArgs, api: ApisauceInstance) => {
  return api.put(`/v1/commitments/create_commitment`, {
    commitment_data: c,
  });
};

export default createCommitment;
